// @flow

import * as R from 'ramda';

import { HttpService } from '~/services';
import {
  getRouteNavigationParamsWithFormattedDate,
  renameKeys,
} from '~/helpers';

export const resolvers = {
  Query: {
    topUpList: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      props: RouteNavigationInputProps,
      { cache }: ApolloCache,
    ): Promise<?TopUpListResponse> => {
      const columnsMapping = {
        DateTimeUtc: 'date',
        TrxId: 'trxId',
        DepositAmount: 'amount',
      };

      const params = getRouteNavigationParamsWithFormattedDate(
        {
          date: ['DateFromUtc', 'DateToUtc'],
          amount: ['AmountFrom', 'AmountTo'],
          trxId: 'TrxId',
        },
        R.invertObj(columnsMapping),
      )(props);

      // Get top up list
      const {
        data: { TopUpList, PageCount = 1 },
      } = await HttpService.client.get('/MyWealth/TopUp/GetTopUpTrxList', {
        params,
      });

      const items: TopUpListItem[] = R.map(
        R.pipe(
          renameKeys(columnsMapping),
          R.assoc('__typename', 'TopUpListItem'),
        ),
        TopUpList,
      );

      const topUpList = {
        data: items,
        pages: PageCount,
        __typename: 'TopUpList',
      };

      cache.writeData({ data: { topUpList }, variables: props });

      return topUpList;
    },
  },
};
